<script setup>
import { clientApi } from '@phoenix/clientApi';
import { PhxStrapFinder, PhxStrapFinderHeader, PhxStrapFinderSections, useStrapFinder } from '@phx-styleguides/iwc';
import { PhxsgLoader } from '@sg/src/View/Components/Atoms/Loader';
import { ref, onMounted } from 'vue';
import ReplaceSection from '@maison/components/strapFinder/sections/ReplaceSection.vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  reference: {
    type: String,
    required: true,
  },
  replaceSection: {
    type: Object,
    required: true,
  },
});

const isLoading = ref(true);
const watch = ref(null);

const strapFinderProps = useStrapFinder();
const { t } = useI18n();

onMounted(async () => {
  try {
    const requestResult = await clientApi.get(
      window.route('api.strapFinder.getWatchFromReference', { reference: props.reference }),
    );

    const data = requestResult?.data?.data;
    if (!data || !data.defaultStrap || !data.defaultBuckle) {
      throw new Error();
    }

    watch.value = data;
  } catch {
    window.Phoenix.notification.create(
      t('StrapFinderConfigurator.errors.noDefaultStrapAndBuckleForThisReference', { reference: props.reference }),
      'error',
    );
    window.location.href = window.route('strap_finder_search_page');
  } finally {
    isLoading.value = false;
  }
});
</script>

<template>
  <div v-if="isLoading" class="center center--and-text">
    <PhxsgLoader />
  </div>

  <phx-strap-finder
    v-else
    :sections="strapFinderProps.sections.value"
    :validated-sections="strapFinderProps.validatedSections.value"
    :register-section="strapFinderProps.registerSection"
    :unregister-section="strapFinderProps.unregisterSection"
  >
    <phx-strap-finder-header :watch-name="$t('StrapFinderConfigurator.title', { name: watch.name })" :price="''" />
    <phx-strap-finder-sections>
      <replace-section
        v-bind="replaceSection"
        :reference="reference"
        :default-strap-size="watch?.defaultStrapSize"
        :default-strap="watch.defaultStrap"
        :default-buckle="watch.defaultBuckle"
      />
    </phx-strap-finder-sections>
  </phx-strap-finder>
</template>
